// extracted by mini-css-extract-plugin
export default {"horizontal":"Divider_horizontal__b8ENM","vertical":"Divider_vertical__CbyQP"};